import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
// Local Components
import TableUI from "./TableUI";
// Types
import {
  ConnectionStatus,
  IConnectionsReport,
  IConnectionsSearchParams,
} from "src/Interfaces/connections";
// Requests
import { getConnectionsTable } from "src/Requests/connections";

interface IConnectionsTable {
  searchParam: IConnectionsSearchParams;
  connectionStatus: ConnectionStatus;
}
const ConnectionsTable: React.FC<IConnectionsTable> = ({
  connectionStatus,
  searchParam,
}: IConnectionsTable) => {
  return (
    <TableTemplate<IConnectionsSearchParams, IConnectionsReport>
      TableUI={({ reports, onAction }) => (
        <TableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={(_, o, pageSize) =>
        getConnectionsTable(searchParam, o, pageSize, connectionStatus)
      }
      refreshTableTime={7000}
    />
  );
};

export default ConnectionsTable;
